module.exports = __webpack_public_path__ + "static/media/texspace.c0a3ac68.png";